import {
	Box,
	Flex,
	ThemeColorVariable,
	ThemeRadiusVariable,
	ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";

type props = {
	activeStep: number;
	totalSteps: number;
	stepCountChange: (nr: number) => void;
};

export const MiniStepper = ({ activeStep: stepCount, totalSteps, stepCountChange }: props) => {
	return (
		<Flex gap={ThemeSpaceVariable.Medium}>
			{Array.from(Array(totalSteps)).map((_, i) => (
				<Box
					key={i}
					borderRadius={ThemeRadiusVariable.XLarge}
					height={ThemeSpaceVariable.Small}
					width={ThemeSpaceVariable.Small}
					onClick={() => stepCountChange(i + 1)}
					backgroundColor={
						stepCount === i + 1 ? ThemeColorVariable.Accent : ThemeColorVariable.AccentActiveAlpha
					}
				></Box>
			))}
		</Flex>
	);
};
